import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import PrismicVue from 'prismic-vue';
import VueTelInputVuetify from 'vue-tel-input-vuetify';
import VueGlide from 'vue-glide-js';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import 'vue-glide-js/dist/vue-glide.css';

// register global utility filters
import * as filters from './filters';

Vue.config.productionTip = false;

Vue.use(VueGlide);
Vue.use(VueTelInputVuetify, {
  vuetify,
});
Vue.use(VueAnalytics, {
  id: 'UA-143793792-2',
  router,
});
Vue.use(PrismicVue, {
  endpoint: 'https://navigate-website.cdn.prismic.io/api/v2',
});


Vue.filter('kFormatter', num => (Math.abs(num) > 999 ? `${Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1))}k` : Math.sign(num) * Math.abs(num)));
// global filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
